export default __webpack_public_path__ + "static/media/check-white.6b8185f1.svg";